<!--
* @Name：合同付款任务审批页面
* @Author: LiHao
* @Date: 2025-06-25
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="合同付款任务审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">付款任务信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">付款任务明细</span>
        </template>
        <task-details :detailsList="cmPayApplyItemDtoList" todo-name="PoApproval" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval :page-context="thisPage" @get-process-info="onGetProcessInfo" />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { coopPayCreateHead } from '@/api/contractPaymentTaskRequest'
import Bridge from '@/components/dsbridge'
import {
  getCatgPurgrp,
  getFinanceManager,
  getProvinceAndFinanceManagerInfoForPay,
  getProvinceManager,
  invalid
} from '@/api/process'

export default {
  name: 'contractPaymentTaskApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'task-details': () => import('./components/TaskDetails.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      // 主单信息
      headInfo: {},
      // 明细信息
      cmPayApplyItemDtoList: [],
      // 附件列表
      attachList: [],
      taskDefKey: '',
      // 审批单ID
      // prCreateHeadId: this.$store.getters.businessKey
      payCreateHeadId: this.$route.query.businessKey
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    thisPage() {
      return this
    }
  },
  methods: {
    // 获取采购申请主单信息和附件列表
    async initData() {
      const headResp = await coopPayCreateHead(this.payCreateHeadId)
      this.headInfo = headResp.data
      this.attachList = this.headInfo.payTaskFile
      this.cmPayApplyItemDtoList = this.headInfo.cmPayApplyItemDtoList
    },
    // 返回到审批待办列表
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    },
    onGetProcessInfo(processInfo) {
      this.taskDefKey = processInfo.taskDefKey
    },
    $stopExecute() {
      throw Error()
    }
  },
  bpmHooks: {
    async setProcessVariables(type) {
      if (type === 'agree') {
        if (this.taskDefKey === 'Activity_1xm1we1') {
          // 获取财经副总
          let financeManager = ''
          const response = await getFinanceManager({ contractNo: this.headInfo.contractNo })
          if (response.success) {
            financeManager = response.data
          } else {
            this.$notify({
              title: '提示',
              message: response.message,
              type: 'warning'
            })
            this.$stopExecute()
          }
          return {
            businessKey: this.payCreateHeadId,
            financeManager,
            opType: type
          }
        } else if (this.taskDefKey === 'Activity_16908en') {
          // 获取省区总经理
          let provinceManager = ''
          if (this.headInfo.attr1 === 'PurchaseContract') {
            const response = await getProvinceAndFinanceManagerInfoForPay({
              contractNo: this.headInfo.contractNo,
              roleCode: 'provinceManager'
            })
            if (response.success) {
              provinceManager = response.data
            } else {
              this.$notify({
                title: '提示',
                message: response.message,
                type: 'warning'
              })
              this.$stopExecute()
            }
          } else {
            const response = await getProvinceManager({ contractNo: this.headInfo.contractNo })
            if (response.success) {
              provinceManager = response.data
            } else {
              this.$notify({
                title: '提示',
                message: response.message,
                type: 'warning'
              })
              this.$stopExecute()
            }
          }
          return {
            businessKey: this.payCreateHeadId,
            provinceManager,
            opType: type
          }
        } else if (this.taskDefKey === 'Activity_1js5uu8') {
          // 获取区域负责人
          let districtManager = ''
          if (this.headInfo.attr1 === 'PurchaseContract') {
            // 获取财经副总
            const response = await getProvinceAndFinanceManagerInfoForPay({
              contractNo: this.headInfo.contractNo,
              roleCode: 'districtManager'
            })
            if (response.success) {
              districtManager = response.data
            } else {
              this.$notify({
                title: '提示',
                message: response.message,
                type: 'warning'
              })
              this.$stopExecute()
            }
          } else {
            const response = await getProvinceManager({ contractNo: this.headInfo.contractNo })
            if (response.success) {
              districtManager = response.data
            } else {
              this.$notify({
                title: '提示',
                message: response.message,
                type: 'warning'
              })
              this.$stopExecute()
            }
          }
          return {
            businessKey: this.payCreateHeadId,
            corpId: this.headInfo.corpId,
            opType: type,
            districtManager
          }
        } else if (this.taskDefKey === 'Activity_192pb9p') {
          // 获取品类采购组审批人
          let catgPurgrpId = ''
          const response = await getCatgPurgrp({ contractNo: this.headInfo.contractNo, attr: this.headInfo.attr1 })
          if (response.success) {
            catgPurgrpId = response.data
          } else {
            this.$notify({
              title: '提示',
              message: response.message,
              type: 'warning'
            })
            this.$stopExecute()
          }
          return {
            businessKey: this.payCreateHeadId,
            catgPurgrpId,
            opType: type
          }
        } else {
          return { opType: type }
        }
      }
    },
    async afterExecute(type) {
      // 流程处理后
      if (type === 'invalid') {
        // 流程被终止进行的方法
        const response = await invalid(this.headInfo.id)
        if (!response || !response.success) {
          this.$notify({
            title: '提示',
            message: response.message,
            type: 'warning'
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
